import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist/dist/umd'
import router from '@/router/index'
import Config from '../src/config.loader'

Vue.use(Vuex)

const api = {
    namespaced: true,

    // state: {
    //     protocol: 'https',
    //     host: 'localhost',
    //     port: 44338,
    //     isLoading: false
    // },
    //servidor de qualidade expedita
    state: {
        protocol: Config.getMetaValue('VUE_APP_BASE_PROTOCOL'),
        host: Config.getMetaValue('VUE_APP_BASE_URL'),
        port: parseInt(Config.getMetaValue('VUE_APP_BASE_PORT')),
        isLoading: false
    },
    //servidor de produçao presspower
    // state: {
    //     protocol: 'https',
    //     host: 'webapi.presspower.pt',
    //     isLoading: false
    // },

    getters: {
        fullUrl: state => {
            return state.port != 0 ? `${state.protocol}://${state.host}:${state.port}/api/` : `${state.protocol}://${state.host}/api/`;
        },
        // fullUrl : state => {
        //     return `${state.protocol}://${state.host}/api/`;
        // },
        isLoading: state => {
            return state.isLoading
        },
        getUrl: state => {
            return state.port != 0 ? `${state.protocol}://${state.host}:${state.port}` : `${state.protocol}://${state.host}`;
        }
    },
    mutations: {
        isLoadingOn(state, data) {
            Vue.set(state, 'isLoading', true)
        },
        isLoadingOff(state, data) {
            Vue.set(state, 'isLoading', false)
        }
    }
}

const auth = {
    namespaced: true,

    state: {
        user: null
    },
    getters: {
        isLoggedIn: state => {
            return state.userID ? true : false;
        },

        getUsername: state => {
            if (state.user != null) {
                return `${state.user}`;
            }
        },

        getUserId: state => {
            return state.userID
        }
    },
    mutations: {
        login(state, data) {
            Vue.set(state, 'user', data.info[0].User.DisplayName)
            //Vue.set(state, 'token', data.token)
            Vue.set(state, 'userID', data.id)
            router.push({ path: '/Home' })
        },
        logout(state, data) {
            Vue.set(state, 'user', null)
            Vue.set(state, 'userID', null)
            //Vue.set(state, 'token', null)
            router.push({ path: '/login' })
        }
    }


}
const vuexLocal = new VuexPersist({
    key: 'auth',
    storage: window.sessionStorage,
    modules: ['auth']

})


export default new Vuex.Store({
    modules: {
        api: api,
        auth: auth
    },
    plugins: [vuexLocal.plugin]

})


// WEBPACK FOOTER //
// ./src/store.js